import React from 'react'
import { motion } from 'framer-motion'
import { Settings as SettingsIcon, Save, Database, Shield, Bell } from 'lucide-react'

const SettingsPage = () => {
  const settingSections = [
    {
      title: 'Configurações Gerais',
      icon: SettingsIcon,
      description: 'Configurações básicas do sistema'
    },
    {
      title: 'Banco de Dados',
      icon: Database,
      description: 'Configurações de conexão e backup'
    },
    {
      title: 'Segurança',
      icon: Shield,
      description: 'Configurações de segurança e permissões'
    },
    {
      title: 'Notificações',
      icon: Bell,
      description: 'Configurações de alertas e notificações'
    }
  ]

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Configurações</h1>
        <p className="text-gray-600 mt-2">
          Gerencie as configurações do sistema
        </p>
      </div>

      {/* Settings Sections */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {settingSections.map((section, index) => {
          const Icon = section.icon
          return (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="admin-card cursor-pointer hover:shadow-md transition-shadow"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-admin-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon className="w-6 h-6 text-admin-600" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-medium text-gray-900 mb-1">
                    {section.title}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {section.description}
                  </p>
                </div>
              </div>
            </motion.div>
          )
        })}
      </div>

      {/* Quick Actions */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="admin-card"
      >
        <h3 className="text-lg font-medium text-gray-900 mb-4">Ações Rápidas</h3>
        <div className="flex flex-wrap gap-3">
          <button className="admin-button admin-button-primary flex items-center space-x-2">
            <Save className="w-4 h-4" />
            <span>Salvar Configurações</span>
          </button>
          <button className="admin-button admin-button-secondary">
            Restaurar Padrões
          </button>
          <button className="admin-button admin-button-secondary">
            Exportar Configurações
          </button>
        </div>
      </motion.div>

      {/* System Info */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="admin-card"
      >
        <h3 className="text-lg font-medium text-gray-900 mb-4">Informações do Sistema</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-gray-600">Versão do Sistema</p>
            <p className="font-medium">1.0.0</p>
          </div>
          <div>
            <p className="text-gray-600">Última Atualização</p>
            <p className="font-medium">28/08/2025</p>
          </div>
          <div>
            <p className="text-gray-600">Status do Banco</p>
            <p className="font-medium text-green-600">Conectado</p>
          </div>
          <div>
            <p className="text-gray-600">Modo de Operação</p>
            <p className="font-medium">Produção</p>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

export default SettingsPage
